module.exports = __webpack_public_path__ + "img/ears-04.3e16f435.svg";